import { motion } from 'framer-motion';
import { CircleHelp, ChevronRight } from 'lucide-react';
import React from 'react';
import ScoreBadge from '../components/ui/ScoreBadge';
import StatusBadge from '../components/ui/StatusBadge';
import Tooltip from '../components/ui/Tooltip';

interface ClauseCardProps {
  title: string;
  tooltip: string;
  score?: number | string;
  status?: 'satisfatorio' | 'atencao' | 'critico';
  badgeType?: 'score' | 'status';
  onArrowClick?: (title: string) => void;
}

const ClauseCard: React.FC<ClauseCardProps> = ({
  title,
  tooltip,
  score,
  badgeType = 'score',
  onArrowClick,
}) => {
  const handleArrowClick = () => {
    if (onArrowClick) {
      onArrowClick(title);
    } else {
      alert('Ação do ChevronRight!');
    }
  };

  const renderBadge = () => {
    if (badgeType === 'status') {
      return <StatusBadge score={typeof score === 'number' ? score : undefined} />;
    } else {
      return score !== undefined ? <ScoreBadge score={score} /> : null;
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="bg-white rounded-lg shadow-sm p-4 flex flex-row items-center justify-between w-full my-2"
    >
      <div className="flex flex-row gap-2 items-center relative">
        <h3 className="text-lg sm:text-xl font-bold text-gray-800">{title}</h3>
        <Tooltip content={tooltip}>
          <CircleHelp className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 cursor-pointer" />
        </Tooltip>
      </div>
      <div className="flex items-center justify-center">
        {renderBadge()}
        <button
          onClick={handleArrowClick}
          className="rounded-full hover:bg-gray-200 transition-colors p-1"
        >
          <ChevronRight className="w-6 h-6 sm:w-7 sm:h-7 text-gray-500" />
        </button>
      </div>
    </motion.div>
  );
};

export default ClauseCard;
